import { BiEdit, BiSolidMessageSquareEdit, BiSolidPin } from "react-icons/bi";
import { IoBanOutline, IoCheckmarkOutline } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { IoEyeOutline } from "react-icons/io5";
import classes from "./TableActionHandler.module.css";
import { LuArrowRightToLine } from "react-icons/lu";
import { FaEye } from "react-icons/fa6";
import { AiFillEye, AiOutlineDelete } from "react-icons/ai";
import { RiDeleteBin5Fill } from "react-icons/ri";

function TableActionHandler(props) {
  return (
    <div className={classes.tableActions}>
      {Object.entries(props).map(([key, handler]) => {
        const Icon = icons[key];
        return (
          Icon && (
            <div
              key={key}
              onClick={handler}
              className={classes?.iconDiv}
              datatype={squareShapes.includes(key) ? key : "basic"}
            >
              {Icon}
            </div>
          )
        );
      })}
    </div>
  );
}

export default TableActionHandler;

const icons = {
  onView: <AiFillEye title="View" />,
  onEdit: <BiSolidMessageSquareEdit title="Edit" />,
  onDelete: <RiDeleteBin5Fill title="Delete" />,
  onApprove: <IoCheckmarkOutline title="Activate" />,
  onReject: <RxCross2 title="Deactivate" />,
  onAssign: <LuArrowRightToLine title="Status" />,
  onPin: <BiSolidPin title="Pin" />,
};

const squareShapes = [
  "onView",
  "onDelete",
  "onAssign",
  "onEdit",
  "onPin",
  "onApprove",
  "onReject",
];
